
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 74 98","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"1.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.482 4.167v89.624M4.27 4.167c-.179 22.8-1.669 33.881 16.263 33.673 16.117-.188 16.06-11.567 16.265-33.673M69.229 4.167v89.624M69.229 42.425H49.157M69.229 4.167C45.336 24.831 49.422 42.425 49.422 42.425","fill":"none","stroke":"#000","stroke-width":"8.33"}})])
          )
        }
      }
    